// console.log('Site:references');

export const $window   = jQuery(window);
export const $document = jQuery(document);
export const $body     = jQuery('body');
export const $wrapper  = jQuery('#wrapper');
export const $header   = jQuery('#header');
export const $content  = jQuery('#content');
export const $footer   = jQuery('#footer');
export const body      = $body[0];
export const wrapper   = $wrapper[0];
export const header    = $header[0];
export const content   = $content[0];
export const footer    = $footer[0];
